<template>
    <div>
        <v-breadcrumbs :items="crumbs" divider="/" style="background-color: #f0f0f0">
        </v-breadcrumbs>
        <v-card class="mx-auto" outlined tile color="#F8F8FF">
        <v-card-title>LPR Images</v-card-title>
        <v-container fluid>
            <v-row>
                <!--
                <v-col cols="12" md="6"><v-btn v-if="validateAccess('system_add')" :loading="btn_loading" :disabled="btn_loading" tile type="submit" small color="primary" @click="viewMore(1, 'create')"><v-icon left x-small dark>fa fa-cogs</v-icon>Create System
                    <template v-slot:loader>
                        <span>Loading...</span>
                    </template>
                    </v-btn>
                </v-col>
                -->
                <v-btn-toggle class="col-12 col-md-6 offset-md-6" style="background: none">
                    <v-btn small disabled>
                        <v-icon small>fa fa-search</v-icon>
                    </v-btn>
                    <v-text-field placeholder="Search" class="search-textfield" hide-details outlined dense v-model="search"></v-text-field>
                </v-btn-toggle>
            </v-row>
            <v-row>
                <v-col cols="12" md="12">
                    <v-autocomplete
                            dense
                            outlined
                            placeholder="All Operator"
                            label="Operator"
                            v-model="operator.selected"
                            @change="execFilter('operator')"
                            :items="operator.items"
                            item-text="name"
                            item-value="OperatorID"
                            :rules="operator.rule"
                            :loading="operator.loader"
                            :disabled="operator.disable"
                            hide-details
                            >
                            </v-autocomplete>
                </v-col>
                <v-col cols="12" md="12">
                    <v-autocomplete
                    dense
                    outlined
                    placeholder="All Car Park"
                    label="Car Park"
                    v-model="carpark.selected"
                    @change="execFilter('carpark')"
                    :items="carpark.items"
                    item-text="name"
                    item-value="CarParkID"
                    :rules="carpark.rule"
                    :loading="carpark.loader"
                    :disabled="carpark.disable"
                    hide-details
                    >
                    </v-autocomplete>
                </v-col>
                <v-col cols="12" md="12">
                    <v-autocomplete
                    dense
                    outlined
                    placeholder="All Gate"
                    label="Gate"
                    v-model="gate.selected"
                    @change="execFilter('gate')"
                    :items="gate.items"
                    item-text="name"
                    item-value="GateID"
                    :rules="gate.rule"
                    :loading="gate.loader"
                    :disabled="gate.disable"
                    hide-details
                    >
                    </v-autocomplete>
                </v-col>
                <v-col cols="12" md="12">
                    <v-autocomplete
                    dense
                    outlined
                    placeholder="Image Type"
                    label="Image Type"
                    v-model="type.selected"
                    @change="execFilter('type')"
                    :items="type.items"
                    item-text="name"
                    :rules="type.rule"
                    :loading="type.loader"
                    :disabled="type.disable"
                    hide-details
                    >
                    </v-autocomplete>
                </v-col>
                <!-- <v-col cols="6" md="12">
                    <vc-date-picker
                    :disabled-dates='dayplusone'
                     :key="counter1" v-model="starttime.item" mode="dateTime" is-range update-on-input :popover="{visibility: 'click'}" @drag="cleardayplusone($event)" @input="getList(1)" :columns="$screens({ default: 1, lg: 2 })" :masks="{ input: 'DD-MM-YYYY' }">
                      <template v-slot="{ inputValue, inputEvents, togglePopover }">
                            <v-text-field
                                @click="togglePopover({ placement: 'bottom-start' })"
                                :value="inputValue.start != null ? `${inputValue.start} - ${inputValue.end}` : ''"
                                @keyup="starttime.item.start = ''; starttime.item.end = ''"
                                dense
                                v-on="inputEvents"
                                hide-details="auto"
                                label="From Date - To Date"
                                outlined
                                autocomplete="off"
                                persistent-hint
                            ></v-text-field>
                        </template>
                      </vc-date-picker>
                </v-col> -->
            </v-row>
            <v-row>
                <v-col cols="12" md="8">
                    <v-pagination
                    v-model="page"
                    :length.sync="pages"
                    :total-visible="6"
                    class="mt-4"
                    style="float: left !important"
                    ></v-pagination><br/><p class="text-caption" style="margin-left: 10px">Page {{page}} of {{pages}}</p>
                </v-col>
            </v-row>
            <v-row dense>
                <v-col><span class="text-body-2">View {{page > 1 ? page * 100 : 1}} - {{page > 1 ? items.length + 100 : items.length}} of {{items.length}}</span></v-col>
                <v-col cols="12" md="12" id="table-parent">
                    <div id="wrapper1">
                        <div id="div1">
                        </div>
                    </div>
                    <v-data-table
                        :headers="headers"
                        :items="items"
                        hide-default-footer
                        :loading="tableloading"
                        loading-text= "Loading Data... Please wait"
                        :items-per-page="100"
                        id="main-table"
                        sort-by="DateCreated"
                        dense
                    >
                    <template slot="item" slot-scope="props">
                        <tr :class="props.item.ValuePassProductID == $route.query.id ? ['blink'] : ''">
                            <td>{{page > 1 ? (page - 1) * 100 + props.index + 1 : props.index + 1}}</td>
                            <td>{{props.item.CarparkID}}</td>
                            <td>{{props.item.CarparkName}}</td>
                            <td>{{ props.item.GateID != '' && props.item.GateID != null ? props.item.GateID :  'N/A' }}</td>
                            <td>{{ props.item.Type }}</td>
                            <td>
                                <v-tooltip top v-if="props.item.PlateNo !== null && props.item.PlateNo != 'N/A'">
                                <template v-slot:activator="{ on }">
                                <a style="text-decoration: underline" id="custom-hover" v-on="on" @click.prevent="viewMore(props.item, 'view_carplateno')">{{props.item.PlateNo}}</a>
                                </template>
                                <span>Car Image</span>
                                </v-tooltip>
                                <span v-else>N/A</span>
                            </td>
                            <td>
                                <v-tooltip top v-if="props.item.PlateNo !== null && props.item.PlateNo != 'N/A'">
                                <template v-slot:activator="{ on }">
                                <a style="text-decoration: underline" id="custom-hover" v-on="on" @click.prevent="viewMore(props.item, 'view_carplateno')"><img class="my-2" style="border: 1px solid #191716" width="360px" :src="props.item.ImageUrl" /></a>
                                </template>
                                <span>Car Image</span>
                                </v-tooltip>
                                <span v-else>N/A</span>
                            </td>
                            <td>{{props.item.CreatedDateTime}}</td>
                            <td>{{props.item.DeletedDateTime}}</td>
                        </tr>
                    </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-container>
        </v-card>
        <v-snackbar
        v-model="swal.notification"
        top
        :color="swal.scolor"
        >
            {{ swal.message }}
        </v-snackbar>
        <viewcarplate :dialog="ma.modal_view_carplateno" :customText="ma.customText" :modal_action_type="ma.modal_action_type" :modalInfo="ma.modalInfo" :allInfo="ma.allInfo"  @closed="onClosed"></viewcarplate>
        <!--
        <create :dialog="ma.modal" :customText="ma.customText" :modal_action_type="ma.modal_action_type" :modalInfo="ma.modalInfo" :allInfo="ma.allInfo" @confirm="onConfirm" @closed="onClosed"></create>
        <alert :dialog="ma.modal_status" :customText="ma.customText" :modal_action_type="ma.modal_action_type" :modalInfo="ma.modalInfo" @confirm="onConfirm" @closed="onClosed"></alert>
        <alertbox2 :dialog="ex.modal" @closed="onClosed" :content="ex.content"></alertbox2>
        -->
    </div>
</template>
<script>
import timer from '../../assets/js/sleeper';
import create from '.././modals/CreateSystem';
import viewsold from '.././modals/ViewVPSoldDetails';
import alert from '.././modals/Alert';
import {ERR} from '../../assets/js/errhandle.js';
import alertbox2 from '../modals/Notification';
import * as moment from "moment";
import * as tz from "moment-timezone";
import {rule} from '../../assets/js/checkPerm';
import viewcarplate from '.././modals/ViewLprCarplate';
import * as AppStorage from '../../assets/js/storage';

export default {
    name: 'LprImage',
    title: 'Lpr Image',
    
    data()  {
        return {
            crumbs: [
                {
                text: 'Home',
                disabled: true,
                href: '#',
                },

                {
                text: 'LPR Parking',
                disabled: true,
                href: '#',
                },

                {
                text: 'LPR Image',
                disabled: true,
                href: '#',
                }
            ],
            items: [],
            search: '',
            headers: [
                 { text: '#', value: 'row', width: '3%' },
                { text: 'CP ID', value: 'CarParkID', width: '3%' },
                { text: 'Car Park', value: 'CarParkName', width: '12%' },
                { text: 'Gate ID', value: 'ValuePassProductID', width: '3%' },
                { text: 'Type', value: 'ValuePassName', width: '12%' },
                { text: 'Plate No', value: 'CostPerValuePass', width: '7%' },
                { text: 'Image', value: 'Images', width: '10%' },
                { text: 'Created Date', value: 'CreatedDateTime', width: '10%', sort: function (a, b) {
                    let aa = moment(a, 'DD-MM-YYYY hh:mm:ss A');
                    let aa2 = aa.toDate();

                    let bb = moment(b, 'DD-MM-YYYY hh:mm:ss A');
                    let bb2 = bb.toDate();

                    return aa2 > bb2 ? -1 : aa2 < bb2 ? 1 : 0;
                }  },
                { text: 'Deleted Date', value: 'DeletedDateTime', width: '10%', sort: function (a, b) {
                    let aa = moment(a, 'DD-MM-YYYY hh:mm:ss A');
                    let aa2 = aa.toDate();

                    let bb = moment(b, 'DD-MM-YYYY hh:mm:ss A');
                    let bb2 = bb.toDate();

                    return aa2 > bb2 ? -1 : aa2 < bb2 ? 1 : 0;
                }  },
            ],
            tableloading: false,
            btn_loading: false,
            pages: 0,
            page: 1,
            swal: {
                notification: false,
                message: '',
                scolor: '',
            },
            ma: {
                modal: false,
                modal_action_type: '',
                modalInfo: [],
                customText: [],
                confirmCreate: false,

                modal_status: false,
                modal_update: false,
                modal_viewsold: false,
                modal_view_carplateno: false,
                readonly: true,
                allInfo: [],
            },

            ex: {
                modal: false,
                content: {
                    headline: '',
                    icon: '',
                    chipColor: '',
                    iconColor: '',
                    maintext: '',
                    smalltext: ''
                }
            },

            operator: {
                items: [],
                itemsFull: [],
                selected: '',
                loader: false,
                disable: false,
                rule: []
            },
            carpark: {
                items: [],
                itemsFull: [],
                selected: '',
                loader: false,
                disable: false,
                rule: []
            },
            gate: {
                items: [],
                itemsFull: [],
                selected: '',
                loader: false,
                disable: false,
                rule: []
            },
            type: {
                items: ['All Image Type','Entry','Exit' ],
                itemsFull: ['All Image Type','Entry', 'Exit'],
                selected: 'All Image Type',
                loader: false,
                disable: false,
                rule: []
            },
            displaystatus: {
                counter: 0,
                selected: null,
                rerender: 0,
                label: 'All Mobile Display Status'
            },
            services: [],
            starttime: {item: {start: '', end: ''}},
            endtime: {item: ''},
            starttimeforapi: '',
            endtimeforapi: '',
            dayplusone: [],
            show: false,
            counter1: 0,
            timezone:''
        }
    },

    components: {create, alert, alertbox2, viewsold,viewcarplate},

    async created(){
        await this.getOperatorFull();
        await this.getCarParkFull();
        await this.getGateFull();
        window.addEventListener("unload", (evt) => this.onUnload({operator: this.operator.selected, carpark: this.carpark.selected}, evt));
        this.operator.selected = JSON.parse(AppStorage.get('filter')).operator;
        this.carpark.selected = JSON.parse(AppStorage.get('filter')).carpark;
        this.getList(1);
        this.horizontalScroll();
    },

    watch: {
        page: {
        handler: function(value) {
            this.items = [];
            this.getList();
        }
        },

        'search': {
        handler: function(value) {
            this.searchTimeOut();
        }
        },
    },

    methods: {
        async getList(pg){
            try{
                this.tableloading = true;
                await this.setTime();
                this.carpark.selected = this.$route.query.cpid == undefined ? this.carpark.selected : this.$route.query.cpid;
                let response = await this.$store.dispatch("getImageList", {page: pg > 0 ? this.page = pg : this.page, operatorid: this.operator.selected, carparkid: this.carpark.selected, search: this.search, gate: this.gate.selected, type: this.type.selected});
                //     }
                let dt = response.data.record;

                let response3 = await this.$store.dispatch("getAllCarpark2", {search: ''});
                // let dt2 = response2.data.record;
                let dt3 = response3.data.record;
                console.log(response3);
                let recordCount = response.data.total;
                
                for(var i=0; i<dt.length; i++){
                    dt[i].row = this.page > 1 ? (this.page - 1) * 100 + i + 1 : i + 1;
                    dt[i].CreatedDateTime = moment(new Date(dt[i].CreatedDateTime)).format('DD-MM-YYYY hh:mm:ss A');
                    dt[i].UpdatedDateTime = moment(new Date(dt[i].UpdatedDateTime)).format('DD-MM-YYYY hh:mm:ss A');
                    dt[i].DeletedDateTime = dt[i].DeletedDateTime  != null ? moment(new Date(dt[i].DeletedDateTime)).format('DD-MM-YYYY hh:mm:ss A') : 'N/A';
                    dt[i].CarparkID = dt[i].CarparkID;
                    dt[i].PlateNo = dt[i].PlateNo;
                    dt[i].GateID = dt[i].GateID;
                    dt[i].Type = dt[i].ImageType;
                    let cp = dt3.find(item => item.CarParkID == dt[i].CarparkID);
                    dt[i].CarparkName = cp == undefined ? 'N/A': cp.CarParkName;
                    dt[i].ImageUrl = dt[i].ImageUrl;
                }

                this.items = dt;
                this.pages = Math.ceil(recordCount / 100);
                this.tableloading = false;
                // if (this.$route.query.cpid || this.$route.query.id)
                // this.$router.replace({'query': null});
            }

            catch(err){
                console.log(err);
            }
        },

        async getOperatorFull(){
            let list = [];
            this.operator.items = [];
            this.operator.selected = "";

            try{
                this.operator.loader = true;
                this.operator.disable = true;

                let self = this;
                let response = await this.$store.dispatch("listOperator", {search: ''});
                let dt = response.data.record;
                if (response.data.code == 'AP000'){
                    this.operator.items.push({name: "All Operator", OperatorID: ""});
                    this.operator.itemsFull.push({name: "All Operator", OperatorID: ""});

                for(var i=0; i<dt.length; i++){
                    if (dt[i].SystemID === 2){
                        dt[i].name = `${dt[i].OperatorID} - ${dt[i].OperatorName}`;
                        this.operator.items.push({name: dt[i].name, OperatorID: dt[i].OperatorID});
                        this.operator.itemsFull.push(dt[i]);
                    }
                }

                this.operator.selected = this.operator.items[0].OperatorID;
                }

                //this.operator.itemsFull = dt;

                this.operator.loader = false;
                this.operator.disable = false;
            }

            catch(err){
                console.log(err);
            }

            return list;
        },

        async getCarParkFull(){
            let list = [];
            this.carpark.items = [];
            this.carpark.selected = "";

            try{
                this.carpark.loader = true;
                this.carpark.disable = true;

                let self = this;

                if (this.operator.selected){
                    let carpark = this.carpark.itemsFull.filter(item => {
                    return item.OperatorID == self.operator.selected;
                    });

                    this.carpark.items.push({name: "All Car Park", CarParkID: ""});

                    for(var i=0; i<carpark.length; i++){
                        carpark[i].name = `${carpark[i].CarParkID} - ${carpark[i].CarParkName}`;
                        this.carpark.items.push({name: carpark[i].name, CarParkID: carpark[i].CarParkID});
                    }

                    //this.operator.selected = this.operator.items[1].OperatorID;
                }

                else{
                    let response = await this.$store.dispatch("getAllCarpark2", {});
                    let dt = response.data.record;
                    if (response.data.code == 'AP000'){
                        this.carpark.items.push({name: "All Car Park", CarParkID: ""});
                        this.carpark.itemsFull.push({name: "All Car Park", CarParkID: ""});

                    for(var i=0; i<dt.length; i++){
                        if (dt[i].SystemID === 2){
                            dt[i].name = `${dt[i].CarParkID} - ${dt[i].CarParkName}`;
                            this.carpark.items.push({name: dt[i].name, CarParkID: dt[i].CarParkID});
                            this.carpark.itemsFull.push(dt[i]);
                        }
                    }

                    this.carpark.selected = this.carpark.items[0].CarParkID;
                    }
                }

                //this.operator.itemsFull = dt;

                this.carpark.loader = false;
                this.carpark.disable = false;
            }

            catch(err){
                console.log(err);
            }

            return list;
        },
        async getGateFull(){
            let list = [];
            this.gate.items = [];
            this.gate.selected = "";

            try{
                this.gate.loader = true;
                this.gate.disable = true;

                let self = this;

                if(this.carpark.selected){
                    let gate = this.gate.itemsFull.filter(item=>{
                        return item.CarParkID == self.carpark.selected;
                    })
                    this.gate.items.push({name: "Select Gate", GateID: "", CarParkID: "", GateUUID: ''});
                    for(var i=0; i<gate.length; i++){
                        gate[i].name = `${gate[i].GateID}`;
                        this.gate.items.push({name: gate[i].name, GateID: gate[i].RefGateID, CarParkID: gate[i].CarParkID, GateUUID: gate[i].GateUUID});
                    }
                }
                else {
                    let response = await this.$store.dispatch("getGateDropDown", {search: ''});
                    let dt = response.data.record;
                    if (response.data.code == 'AP000'){
                        console.log(dt[0]);
                        this.gate.items.push({name: "Select Gate", GateID: "", CarParkID: "", GateUUID: ''});
                        this.gate.itemsFull.push({name: "Select Gate", GateID: "", CarParkID: "", GateUUID: ''});
    
                        for(var i=0; i<dt.length; i++){
                            dt[i].name = `${dt[i].GateID}`;
                            this.gate.items.push({name: dt[i].name, GateID: dt[i].RefGateID, CarParkID: dt[i].CarParkID, GateUUID: dt[i].GateUUID});
                            this.gate.itemsFull.push({name: dt[i].name, GateID: dt[i].RefGateID, CarParkID: dt[i].CarParkID, GateUUID: dt[i].GateUUID});
                        }
                    }
                }


                this.gate.loader = false;
                this.gate.disable = false;
            }

            catch(err){
                console.log(err);
            }

            return list;
        },
        validateAccess(val){
            let access = JSON.parse(JSON.stringify(this.$store.getters.getAccess))
            return rule.checkaccess(val, access);
        },

        viewMore(row, flag){
            //this.autoRefresh = 0;
            if (flag == 'delete'){
                this.ma.modal_status = true;
                this.ma.modalInfo = row;
            }

            if (flag == 'create'){
                this.ma.modal = true;
                this.ma.allInfo = this.items;
            }

            if (flag == 'update'){
                this.ma.modal_update = true;
                this.ma.modalInfo = row;
                this.ma.allInfo = this.items;
                this.ma.readonly = false;
            }

            if (flag == 'view'){
                this.ma.modal_update = true;
                this.ma.modalInfo = row;
                this.ma.allInfo = this.items;
                this.ma.readonly = true;
            }

            if(flag == 'view_carplateno'){
                this.ma.modal_view_carplateno = true;
                console.log(row);
                const selected = {
                    CarParkID: row.CarparkID,
                    CarPlateNo: row.PlateNo,
                    mobile: row.PlateNo
                }
                this.ma.modalInfo = selected;

                this.ma.allInfo = this.items;
                this.ma.readonly = true;
            }

            this.ma.customText = {text1: "Gate ID", text2: "Name"};
            this.ma.modal_action_type = flag;
        },

        viewSoldDetails(row){
            this.ma.modal_viewsold = true;
            this.ma.modalInfo = row;
        },

        update(row){
            this.ma.modalInfo = row;
            this.$router.push({ name: "Update", params: {id: row.ValuePassProductID}});
        },

        onClosed(value){
            console.log(value)
            if (value == false){
                this.ma.modal = value;
                this.ma.modal_status = value;
                this.ma.modal_update = value;
                this.ma.modal_viewsold = value;
                this.ex.modal = value;
                this.ma.modal_view_carplateno= value;
            }
        },

        /*
        onConfirm(value){
            console.log(value)
            if (value.flag === 'create'){
                this.ma.confirmCreate = true;
                this.ma.modal = false;
                this.addSystem(value);
            }

            if (value.flag === 'update'){
                this.ma.modal_update = false;
                this.systemUpdate(value);
            }

            if (value === true){
                if (this.ma.modal_action_type == 'delete')
                {
                    this.ma.modal_status = false;
                    this.systemRemove();
                }
            }
        },
        */

        async execFilter(type){
            if (type == 'system'){
                await this.getOperatorFull();
                await this.getCarParkFull();
                await this.searchTimeOut();
            }

            if (type == 'operator'){
                await this.getCarParkFull();
                await this.searchTimeOut();
            }

            if (type == 'carpark'){
                await this.getGateFull();
                await this.searchTimeOut();
            }
            if (type == 'gate'){
                // await this.getGateFull();
                await this.searchTimeOut();
            }
            if (type == 'type'){
                // await this.getGateFull();
                await this.searchTimeOut();
            }

            if (type == 'displaystatus'){
                this.displaystatus.counter++;
                if (this.displaystatus.counter % 3 == 0){
                    this.displaystatus.rerender++;
                    this.displaystatus.selected = null;
                    this.displaystatus.label = "All Mobile Display Status";
                }

                if (this.displaystatus.selected === true){
                    this.displaystatus.label = "Mobile Display Status Enable";
                }

                if (this.displaystatus.selected === false){
                    this.displaystatus.label = "Mobile Display Status Disable";
                }
                await this.searchTimeOut();
            }
        },

        searchTimeOut() {

          clearTimeout(this.timeout);

          // Make a new timeout set to go off in 800ms
          this.timeout = setTimeout(() => {
          this.getList(1);
          }, 800);
        },

        onUnload(filter, evt){
            AppStorage.set('filter', JSON.stringify(filter));
        },

        horizontalScroll(){
            var wrapper1 = document.getElementById('wrapper1');
            var wrapper2 = document.querySelector('.v-data-table__wrapper');
            document.getElementById('wrapper1').style.width = `${String(document.getElementsByClassName("v-data-table__wrapper")[0].offsetWidth)}px`;
            document.getElementById('div1').style.width = `${String(document.getElementsByTagName("table")[0].offsetWidth)}px`;

            if (document.getElementsByClassName("v-data-table-header")[0].offsetWidth < document.getElementById("table-parent").offsetWidth)
                    document.getElementById('wrapper1').style.display = "none";

                else
                    document.getElementById('wrapper1').style.display = "block";

            window.addEventListener('resize', function() {
                document.getElementById('wrapper1').style.width = `${String(document.getElementsByClassName("v-data-table__wrapper")[0].offsetWidth)}px`;
                document.getElementById('div1').style.width = `${String(document.getElementsByTagName("table")[0].offsetWidth)}px`;

                if (document.getElementsByClassName("v-data-table-header")[0].offsetWidth < document.getElementById("table-parent").offsetWidth)
                    document.getElementById('wrapper1').style.display = "none";

                else
                    document.getElementById('wrapper1').style.display = "block";
            });

            const myObserver = new ResizeObserver(entries => {
            entries.forEach(entry => {
                document.getElementById('wrapper1').style.width = `${String(document.getElementsByClassName("v-data-table__wrapper")[0].offsetWidth)}px`;
                document.getElementById('div1').style.width = `${String(document.getElementsByTagName("table")[0].offsetWidth)}px`;
                // console.log('table', document.getElementsByClassName("v-data-table__wrapper")[0].offsetWidth);
                // console.log('parent', document.getElementById("table-parent").offsetWidth);

                if (document.getElementsByClassName("v-data-table-header")[0].offsetWidth < document.getElementById("table-parent").offsetWidth)
                    document.getElementById('wrapper1').style.display = "none";

                else
                    document.getElementById('wrapper1').style.display = "block";
            });
            });

            const someEl = document.getElementsByTagName("table")[0];
            myObserver.observe(someEl);


            wrapper1.onscroll = function() {
            wrapper2.scrollLeft = wrapper1.scrollLeft;
            };
            wrapper2.onscroll = function() {
            wrapper1.scrollLeft = wrapper2.scrollLeft;
            };
        },
        setTime(){
            let dte = new Date();
            let starttime = this.starttime.item.start !== '' ? moment(new Date(this.starttime.item.start).toUTCString()).format('YYYY-MM-DD HH:mm:ss') : null;
            let endtime = this.starttime.item.end !== '' ? moment(new Date(this.starttime.item.end).toUTCString()).format('YYYY-MM-DD HH:mm:ss') : null;
            if (this.starttime.item.start == ""){
                this.starttime.item.start = new Date(moment(starttime).add(1, 'days'));
                this.starttime.item.end = new Date(endtime);
            }
            console.log('starttime', starttime);
            console.log('endtime', endtime);
             if( starttime != null && ( starttime.includes('1970') || starttime.includes('Invalid date'))){
                starttime = null
            }
            if( endtime != null && (endtime.includes('1970') || endtime.includes('Invalid date'))){
                endtime = null
            }
            this.starttimeforapi = starttime;
            this.endtimeforapi = endtime;

            // Add a day
            let dte2 = new Date(moment(endtime).add(1, 'days'))
            console.log('dte', new Date(moment(endtime).add(1, 'days')));
            this.dayplusone = null
        },
        cleardayplusone(v){
            let dte2 = new Date(moment(v.start).add(31, 'days'));
            this.dayplusone = [
                {
                start: dte2,
                end: null
                },
            ];
        },
        isToday() {
            return moment(new Date()).format('DD-MM-YYYY');
        },
    }
}
</script>